import {useEffect, useId, useState} from "react";
import {CheckIcon, SearchIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {GradeToString} from "../students/list";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {CurrencyFormat, NumberToPersianLetters, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";

interface studentsInterface {
    id: number, // studentId
    name: string,
    class: string,
    grade: number,
    isSelected: boolean,
}

export const AdminFinanceGroupContractModal = (props: { active: boolean, closeHandler: any }) => {
    const [loaded, setLoaded] = useState(false);
    const [list, setList] = useState([] as studentsInterface[]);
    const [data, setData] = useState({
        tuition: 0,
        extraProgramCost: 0,
    });
    const fetchList = () => {
        setLoaded(false);
        PostJSON(
            Apis.server + '/core/admins/finance/group/get-students/no-contract',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: {
                    id: number, // studentId
                    name: string,
                    class: string,
                    grade: number,
                }[] | null,
                tuitionPrice: number,
                extraProgramCost: number,
            }) => {
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setLoaded(true);
                let lst = [] as studentsInterface[];
                if (d.list !== null) {
                    d.list.forEach((s, i) => {
                        lst.push({
                            id: s.id,
                            name: s.name,
                            grade: s.grade,
                            class: s.class,
                            isSelected: true,
                        });
                    });
                }
                setList([...lst]);
                setData({
                    tuition: d.tuitionPrice,
                    extraProgramCost: d.extraProgramCost,
                });
            },
            () => {
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add('body-no-scroll');
            setLevel('select');
            fetchList();
            setExtraPrograms(false);
            setOffErr(false);
            setOffPercent('0')
        } else {
            document.body.classList.remove('body-no-scroll');
        }
    }, [props.active]);
    const [search, setSearch] = useState('');
    useEffect(() => {
        if (!loaded || level !== 'select')
            return;
        const filter = search.toUpperCase();
        const lst = document.querySelector('.reports--select-employee-buttons1');
        const btns = (lst as HTMLDivElement).getElementsByTagName('button');
        for (let i = 0; i < btns.length; i++) {
            const b = btns[i].getElementsByTagName('span')[0];
            const v = b.innerHTML.toUpperCase();
            if (v.indexOf(filter) > -1)
                btns[i].style.display = "";
            else
                btns[i].style.display = "none";
        }
    }, [search]);
    const [level, setLevel] = useState('select' as 'select' | 'fill');
    const [offErr, setOffErr] = useState(false);
    const offId = useId();
    const [extraPrograms, setExtraPrograms] = useState(false);
    const [offAmount, setOffPercent] = useState('0');
    const saveChanges = () => {
        const lst = [...list];
        const finalList = [] as number[];
        lst.forEach(e => {
            if (e.isSelected)
                finalList.push(e.id);
        });
        const _off = offAmount === '' ? 0 : parseInt(offAmount);
        if (_off < 0 || _off > data.tuition) {
            setOffErr(true);
            return;
        }
        const _extra = extraPrograms ? data.extraProgramCost : 0;
        const total = (data.tuition - _off) + _extra;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/finance/group/sign-contract',
            {
                data: JSON.stringify([...finalList]),
                price: total.toString(),
                offAmount: _off.toString(),
                extraProgramCost: _extra.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                count: number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                props.closeHandler();
                ShowSnackbar(
                    `قرارداد برای ${StringDigitsConvertToPersian(CurrencyFormat(d.count))} دانش‌آموز تنظیم شد.`,
                    'باشه',
                    5000,
                );
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const isAllChecked = () => {
        const lst = [...list];
        let isAllChecked = true;
        lst.forEach(e=>{
            if(!e.isSelected)
                isAllChecked = false;
        });
        return isAllChecked;
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={loaded ? {top: 20} : {}}>
                <div className="web-modal-header">
                    <div><b>تنظیم قرارداد گروهی</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="reports--select-employee">
                        {
                            loaded ?
                                (
                                    level === 'fill' ?
                                        <>
                                            <div className="add-student">
                                                <label>مبلغ نهایی شهریه:</label>
                                                <span style={{
                                                    display: 'block',
                                                    margin: '5px 0 0 0',
                                                    fontWeight: 400,
                                                    color: '#0a53be'
                                                }}>{
                                                    NumberToPersianLetters(
                                                        (data.tuition - (offAmount === '' ? 0 : parseInt(offAmount))) +
                                                        (extraPrograms ? data.extraProgramCost : 0)
                                                    ) + " تومان"
                                                }</span>
                                                <div style={{height: 20}}/>
                                                <label htmlFor={offId}>مبلغ تخفیف:</label>
                                                <input
                                                    type="number"
                                                    min={0}
                                                    max={100}
                                                    className={"form-control" + (offErr ? ' is-invalid' : '')}
                                                    value={offAmount}
                                                    onChange={e => {
                                                        const t = e.currentTarget.value;
                                                        setOffPercent(t);
                                                        setOffErr(false);
                                                    }}
                                                />
                                                <div className={"invalid-feedback " + (offErr ? 'd-block' : 'd-none')}>
                                                    لطفا یک مبلغ صحیح وارد کنید.
                                                </div>
                                                <div style={{height: 20}}/>
                                                <button
                                                    className={"techaran-checkbox" + (extraPrograms ? ' active' : '')}
                                                    onClick={() => setExtraPrograms(v => !v)}>
                                                    <i><CheckIcon/></i>
                                                    <span>فوق برنامه<em>مبلغ {CurrencyFormat(data.extraProgramCost)} تومان اضافه می‌شود.</em></span>
                                                </button>
                                                <div className="d-flex justify-content-end align-items-center"
                                                     style={{gap: 20, marginTop: 30}}>
                                                    <button className="cancel-button" onClick={props.closeHandler}>
                                                        <b>انصراف</b>
                                                    </button>
                                                    <button className="btn-pay" onClick={saveChanges}>
                                                        <b>ذخیره تغییرات</b>
                                                    </button>
                                                </div>
                                            </div>
                                        </> :
                                        <>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <label>انتخاب دانش‌آموزان</label>
                                                <button className="btn-pay" onClick={() => {
                                                    const lst = [...list];
                                                    if (lst.findIndex((e) => e.isSelected) < 0) {
                                                        ShowSnackbar('لطفا حداقل یک دانش‌آموز را انتخاب کنید.', 'باشه', 5000);
                                                        return;
                                                    }
                                                    setLevel('fill');
                                                }}>
                                                    <b>مرحله بعدی</b>
                                                </button>
                                            </div>
                                            <div className="pick-device-search">
                                                <button><SearchIcon/></button>
                                                <input type="text"
                                                       value={search}
                                                       onChange={e => setSearch(e.currentTarget.value)}
                                                       onBlur={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.remove('active')}
                                                       onFocus={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.add('active')}
                                                       className="f-roboto"
                                                       placeholder={"جستجو براساس نام یا کلاس..."}
                                                />
                                            </div>
                                            {
                                                search.trim() === '' && list.length > 0 ?
                                                    <>
                                                        <hr/>
                                                        <button className={"techaran-checkbox" + (isAllChecked() ? ' active':'')} onClick={()=>{
                                                            const isChecked = isAllChecked();
                                                            if(isChecked)
                                                                setList(v=>{
                                                                    let x = [...v];
                                                                    x.forEach(r=> {
                                                                        r.isSelected = false;
                                                                    });
                                                                    return x;
                                                                });
                                                            else
                                                                setList(v=>{
                                                                    let x = [...v];
                                                                    x.forEach(r=> {
                                                                        r.isSelected = true;
                                                                    });
                                                                    return x;
                                                                });
                                                        }}>
                                                            <i><CheckIcon/></i>
                                                            <span>انتخاب همه</span>
                                                        </button>
                                                        <hr/>
                                                    </> : null
                                            }
                                            <div className="reports--select-employee-buttons1">
                                                {
                                                    list.map((e, i) =>
                                                            <button key={"KJds83jns8932d" + i}
                                                                    className={"techaran-checkbox" + (e.isSelected ? ' active' : '')}
                                                                    onClick={() => setList(v => {
                                                                        let x = [...v];
                                                                        const id = x.findIndex(r => r.id === e.id);
                                                                        x[id].isSelected = !x[id].isSelected;
                                                                        return x;
                                                                    })}>
                                                                <i>
                                                                    <CheckIcon/>
                                                                </i>
                                                                <span>
                                            {e.name}
                                                                    <em>{(e.class === '' ? 'بدون کلاس - ' : `${e.class} - `) + GradeToString(e.grade)}</em>
                                        </span>
                                                            </button>
                                                    )
                                                }
                                            </div>
                                        </>
                                ) :
                                <div className="d-flex justify-content-center align-items-center"
                                     style={{padding: '70px 0'}}>
                                    <div className="spinner-border" style={{color: '#2b2b2b'}}/>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};